module.exports = __webpack_public_path__ + "img/cta-banner.d15173e0.png";